const CTE = 'CTE';
const GFKNEWRON = 'gfknewron';
const NONE = '__NONE__';

export const PageElementClickedEvent = 'Page Element Clicked';

type ReturnType = {
  event: 'Page Element Clicked';
  tags: {
    access: string;
    elementCategory: string;
    elementName: string;
    pageName: string;
    section: string;
  };
};

export const pageElementClicked = (
  elementName: string,
  properties?: Object,
  access = GFKNEWRON,
  elementCategory = CTE
): ReturnType => {
  const routes = window.location.pathname.split('/');
  const pageName = routes[2] || NONE;
  const section = routes[3] || NONE;
  return {
    event: PageElementClickedEvent,
    tags: { ...properties, access, elementCategory, elementName, pageName, section },
  };
};
